export enum BankLineProvider {
  BankTransactionService = 'bank_transaction_service',
}
